import type { JsonCustomConvert } from 'json2typescript'
import type PropelloCustomerStatusEnum from '@/services/enums/PropelloCustomerStatusEnum'
import { JsonConverter } from 'json2typescript'

@JsonConverter
export default class PropelloCustomerStatusEnumConverter implements JsonCustomConvert<PropelloCustomerStatusEnum> {
  serialize(propelloCustomerStatus: PropelloCustomerStatusEnum): string {
    return propelloCustomerStatus.toString()
  }

  deserialize(propelloCustomerStatus: string): PropelloCustomerStatusEnum {
    return propelloCustomerStatus as PropelloCustomerStatusEnum
  }
}
